// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__i8C7q","tyre":"style_tyre__l5-HI"};